import EngineDebug from "../EngineDebug";

import * as madnes from "./madnes";
import * as mobject from "./madnes_object.js";
import * as manim from "./madnes_anims.js";
// import {main_phaser} from "./MadnesApp";

window["madnes"] = madnes;
window["mobject"] = mobject;
window["manim"] = manim;

// window["mphaser"] = main_phaser;

export default class MadnesDebug extends EngineDebug {

    constructor() {
        super();
    }
}